<div class="page-container">
    <h1>Users</h1>
    <div class="container">
        <div style="display: flex; justify-content: space-between;">
            <mat-form-field class="form-field">
                <mat-label>Search</mat-label>
                <input matInput  placeholder="Type something..." #input>
            </mat-form-field>
            <div style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
            <button readOnly [hide]="true" mat-flat-button color="primary" (click)="addNew('user')"
            >Add New</button>
            </div>
            
        </div>
        <div class="table-container">
            <table mat-table [dataSource]="dataSource"
                   class="mat-elevation-z8 table"
                   matSort>

                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header [style.width.%]="10"> User Name </th>
                    <td mat-cell *matCellDef="let element" [style.width.%]="20"> {{element?.name}} </td>
                    
                </ng-container>

                <ng-container matColumnDef="email">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header [style.width.%]="10"> User email </th>
                    <td mat-cell *matCellDef="let element" [style.width.%]="20"> {{element?.email}} </td>
                    
                </ng-container>

                <ng-container matColumnDef="phone">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header [style.width.%]="10"> User phone </th>
                    <td mat-cell *matCellDef="let element" [style.width.%]="20"> {{element?.phone}} </td>
                    
                </ng-container>

                <ng-container matColumnDef="role">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header [style.width.%]="10"> User role </th>
                    <td mat-cell *matCellDef="let element" [style.width.%]="20"> {{element?.role}} </td>
                    
                </ng-container>

                <ng-container matColumnDef="update">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header [style.width.%]="10"> Update user </th>
                    <td mat-cell *matCellDef="let element" [style.width.%]="20"> 
                        <button readOnly mat-button mat-icon-button onclick="this.blur()" (click)="editUser(element)" >
                            <mat-icon>
                                edit
                            </mat-icon>
                        </button>
                    </td>
                </ng-container>

                <ng-container  matColumnDef="dalete">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header [style.width.%]="10"> Delete </th>
                    <td mat-cell *matCellDef="let element" [style.width.%]="20"> 
                        <button readOnly mat-button mat-icon-button onclick="this.blur()" (click)="deleteUser(element)">
                            <mat-icon>
                                delete
                            </mat-icon>
                        </button>
                    </td>
                </ng-container>
              



                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

                <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                    [ngClass]="row.isError ? 'error-row' : ''"
                   ></tr>

              
                <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="4">No data matching the filter "{{input.value}}"</td>
                </tr>
            </table>
            <div class="loading-wrapper-transparent" *ngIf="loading">
                <mat-spinner diameter="30"></mat-spinner>
            </div>
        </div>
        <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="pageSize"></mat-paginator>

    </div>
   


   
</div>
